import { useState } from "react";
import { useAppDispatch } from "app/hooks";
import { logOut } from "features/auth/authSlice";
import { useMediaQuery, useTheme } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import SimpleDialog from "components/SimpleDialog";
import SideBar from "./SideBar";
import TopBar from "./TopBar";

const MainNavigation: React.FC = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <>
      {isLargeScreen ? (
        <SideBar onLogout={() => setShowConfirmModal(true)} />
      ) : (
        <TopBar onLogout={() => setShowConfirmModal(true)} />
      )}

      {showConfirmModal && (
        <SimpleDialog
          title="Logga ut"
          message="Är du säker på att du vill logga ut?"
          confirmProps={{
            children: "Logga ut",
            color: "error",
            startIcon: <LogoutIcon />,
          }}
          onClose={() => setShowConfirmModal(false)}
          onConfirm={() => dispatch(logOut())}
        />
      )}
    </>
  );
};

export default MainNavigation;
